import { IMobileInventoryCount } from '../models/IMobileInventoryCount';

export interface WarehouseResolution {
  warehouseName: string | undefined;
  shouldSave: boolean;
}

interface WarehouseLike {
  warehouseId: number;
  warehouseName: string;
}

/**
 * Determines whether an inventory count's warehouse name needs to be resolved
 * from the warehouse list and saved. Only resolves (and saves) when warehouseName
 * is absent and a matching warehouse is actually found — prevents a spurious API
 * call when no warehouse matches the stored warehouseId.
 */
export function resolveWarehouseForCount(
  details: Pick<IMobileInventoryCount, 'warehouseName' | 'warehouseId'>,
  warehouses: WarehouseLike[]
): WarehouseResolution {
  if (details.warehouseName) {
    return { warehouseName: details.warehouseName, shouldSave: false };
  }

  const match = warehouses.find((w) => w.warehouseId === details.warehouseId);
  return { warehouseName: match?.warehouseName, shouldSave: match != null };
}
